export const ExternalLinks = {
  ServiceDesk: 'https://support.over-c.com/customer-support',
  TermsAndConditions: 'https://over-c.com/end-user-licence-agreement-eula/',
  PrivacyPolicy: 'https://over-c.com/legal/privacy-policy',
  SupportCentre: 'https://over-c.com/knowledge-base/',
};
